import { AutoComplete, Input, Select, Tag, Tooltip } from "antd";
import { useState } from "react";
import {
  classification_select,
  position_select,
  seniority_select,
  state_select,
} from "Benchmarking/Config/SelectData";
import "Benchmarking/Scss/SearchAdvanceFacultyModal.scss";
import { getFacultySuggestSearch } from "Benchmarking/Services/Author";
import { getDepartmentSuggestSearch } from "Benchmarking/Services/Department";
import { getInstitutionSuggestSearch } from "Benchmarking/Services/Institution";
import { getSuggestSearchAuthors } from "Explore/Services/Author";

const SearchAdvanceFacultyModal = ({ filters, setFilters }) => {
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [currentSearchQueryValue, setCurrentSearchQueryValue] = useState("");
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);

  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          height: "28px",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const tagRender = (label, closable, onClose) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const handleInputChangeFaculty = (value) => {
    if (value) {
      getSuggestSearchAuthors(value, (res) => {
        setFacultyOptions(
          res.map((item) => {
            return {
              ...item,
              value: item.name,
            };
          })
        );
      });
      setCurrentSearchQueryValue(value);
    } else {
      setFilters({ ...filters, query: null });
      setCurrentSearchQueryValue("");
    }
  };

  const handleInputConfirmFaculty = (value, option) => {
    setFilters({
      ...filters,
      query: `${option.name}`,
    });
  };
  const onChangePosition = (value) => {
    setFilters({
      ...filters,
      positions: value,
    });
  };
  const onChangeSeniority = (value) => {
    setFilters({
      ...filters,
      seniorities: value,
    });
  };

  const onChangeInstitution = (value) => {
    setFilters({
      ...filters,
      institutions: value,
    });
  };
  const onChangeDepartment = (value) => {
    setFilters({
      ...filters,
      departments: value,
    });
  };
  const onChangeClassification = (value) => {
    setFilters({
      ...filters,
      classifications: value,
    });
  };
  const onChangeState = (value) => {
    setFilters({
      ...filters,
      states: value,
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const handleOnSearchInstitution = (value) => {
    if (value) {
      getInstitutionSuggestSearch(value, (res) => {
        let option_list = res.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
          };
        });
        option_list = [
          {
            value: value,
            label: value,
          },
          ...option_list,
        ];
        setInstitutionOptions(option_list);
      });
    }
  };
  const handleOnSearchDepartment = (value) => {
    if (value) {
      getDepartmentSuggestSearch(value, (res) => {
        let option_list = res.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
          };
        });
        option_list = [
          {
            value: value,
            label: value,
          },
          ...option_list,
        ];
        setDepartmentOptions(option_list);
      });
    }
  };

  return (
    <div className="search-advanced-faculty-modal">
      <div className="search-bar">
        <AutoComplete
          options={facultyOptions}
          placeholder="Enter to search"
          onChange={handleInputChangeFaculty}
          onSelect={handleInputConfirmFaculty}
          style={{ width: "80%" }}
        >
          <Input
            style={{ height: "35px" }}
            onPressEnter={() => {
              setFilters({ ...filters, query: currentSearchQueryValue });
            }}
          />
        </AutoComplete>
        <div
          className="advanced-search-button"
          onClick={() => setOpenAdd(!openAdd)}
          style={{
            backgroundColor: openAdd
              ? "var(--explore-color)"
              : "var(--benchmarking-color)",
          }}
        >
          <p>{openAdd ? "Close Advanced search" : "Advanced Search"}</p>
        </div>
      </div>
      {openAdd && (
        <div className="advanced-search">
          <div className="personal">
            <p className="sub-title-search-advance-modal">Personal</p>
            <Select
              className="filter-item"
              showSearch
              value={filters.positions ? filters.positions : []}
              placeholder="Position"
              optionFilterProp="children"
              mode="multiple"
              allowClear
              tagRender={tagRenderForSelect}
              onChange={onChangePosition}
              filterOption={filterOption}
              options={position_select}
              style={{
                width: "49%",
                marginBottom: "10px",
                height: "35px",
                marginRight: "2%",
              }}
            />
            <Select
              mode="multiple"
              value={filters.seniorities ? filters.seniorities : []}
              allowClear
              className="filter-item"
              showSearch
              tagRender={tagRenderForSelect}
              placeholder="Seniority"
              optionFilterProp="children"
              onChange={onChangeSeniority}
              filterOption={filterOption}
              options={seniority_select}
              style={{ width: "49%", height: "35px" }}
            />
          </div>
          <div>
            <p className="sub-title-search-advance-modal">Affiliation</p>
            <Select
              mode="multiple"
              value={filters.institutions ? filters.institutions : []}
              allowClear
              className="filter-item"
              showSearch
              tagRender={tagRenderForSelect}
              placeholder="Institution"
              optionFilterProp="children"
              onSearch={handleOnSearchInstitution}
              onChange={onChangeInstitution}
              filterOption={filterOption}
              options={institutionOptions}
              style={{
                width: "49%",
                marginBottom: "10px",
                height: "35px",
                marginRight: "2%",
              }}
            />
            <Select
              mode="multiple"
              value={filters.departments ? filters.departments : []}
              allowClear
              className="filter-item"
              showSearch
              tagRender={tagRenderForSelect}
              placeholder="Department"
              optionFilterProp="children"
              onSearch={handleOnSearchDepartment}
              onChange={onChangeDepartment}
              filterOption={filterOption}
              options={departmentOptions}
              style={{ width: "49%", marginBottom: "10px", height: "35px" }}
            />
            <Select
              mode="multiple"
              value={filters.classifications ? filters.classifications : []}
              allowClear
              className="filter-item"
              showSearch
              tagRender={tagRenderForSelect}
              placeholder="Classification"
              optionFilterProp="children"
              onChange={onChangeClassification}
              filterOption={filterOption}
              options={classification_select}
              style={{
                width: "49%",
                marginBottom: "10px",
                height: "35px",
                marginRight: "2%",
              }}
            />
            <Select
              mode="multiple"
              value={filters.states ? filters.states : []}
              allowClear
              className="filter-item"
              showSearch
              tagRender={tagRenderForSelect}
              placeholder="State"
              optionFilterProp="children"
              onChange={onChangeState}
              filterOption={filterOption}
              options={state_select}
              style={{ width: "49%", height: "35px" }}
            />
          </div>
        </div>
      )}
      {!openAdd && (
        <div className="filters-search-modal">
          {filters.positions && (
            <div className="group-filters">
              <p>Position: </p>
              {filters.positions.map((item) => tagRender(item, null, null))}
            </div>
          )}
          {filters.seniorities && (
            <div className="group-filters">
              <p>Seniority: </p>
              {filters.seniorities.map((item) =>
                tagRender(seniority_select[item - 1].label, null, null)
              )}
            </div>
          )}
          {filters.institutions && (
            <div className="group-filters">
              <p>Institution: </p>
              {filters.institutions.map((item) => tagRender(item, null, null))}
            </div>
          )}
          {filters.departments && (
            <div className="group-filters">
              <p>Department: </p>
              {filters.departments.map((item) => tagRender(item, null, null))}
            </div>
          )}
          {filters.classifications && (
            <div className="group-filters">
              <p>Classification: </p>
              {filters.classifications.map((item) =>
                tagRender(item, null, null)
              )}
            </div>
          )}
          {filters.states && (
            <div className="group-filters">
              <p>States: </p>
              {filters.states.map((item) => tagRender(item, null, null))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchAdvanceFacultyModal;
